import { render, staticRenderFns } from "./Dialog_GiftOfTeachingEquipmentForNewStudent.vue?vue&type=template&id=7da76eda&"
import script from "./Dialog_GiftOfTeachingEquipmentForNewStudent.vue?vue&type=script&lang=js&"
export * from "./Dialog_GiftOfTeachingEquipmentForNewStudent.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_GiftOfTeachingEquipmentForNewStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports